import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_CUSTOMER_COMPANY_LIST:
      return { ...action.customerCompanyList };
    default:
      return state;
  }
};
